/**************************************************************************************************************************************************
*   MODULE NAME     :  Footer
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  11-01-2021
*   DESCRIPTION     :  Component to load Application Footer
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Container fluid="true">
          <Row>
            <Col className="copyrightInfo">
              <h4>GLSD(Global Literature Screening Database){"       "}
              <span className="copyrightText">
                (&copy; {new Date().getFullYear()} Eli Lilly and Company,All Right Reserved.)
              </span>
              </h4>
            </Col>
            <Col sm={6} className="appInfo text-right" >
              <Row>
                <Col className="appenvversion" sm={{ span: 9, offset: 3 }}>
                  <Row>
                    <Col>
                      <span>API Environment : </span>
                      <strong className="ml-2">{this.props.env}</strong>
                    </Col>
                    <Col className="text-center">
                      {" "}
                      <span>API Version : </span>
                      <strong className="ml-2">{this.props.version}</strong>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}

export default Footer;
